import React from 'react';

import { ConsumptionPageTypes } from 'src/types/consumption';

import * as customStyled from './styles';
interface ContentDescriptionProps extends ConsumptionPageTypes.CommonUIProps {
  description: string;
}

const ContentDescription: React.FC<ContentDescriptionProps> = ({
  description,
  spaceY
}) => {
  return (
    <p
      data-testid="content-description"
      css={customStyled.description(spaceY as string)}>
      {description}
    </p>
  );
};

export default React.memo(ContentDescription);
